const lines = {
  "5x3-v2": [
    [
      [1, 1, 1, 1, 1],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
    ],
    [
      [1, 0, 1, 0, 1],
      [0, 1, 0, 1, 0],
      [0, 0, 0, 0, 0],
    ],
    [
      [1, 0, 0, 0, 1],
      [0, 1, 1, 1, 0],
      [0, 0, 0, 0, 0],
    ],
    [
      [1, 0, 0, 0, 1],
      [0, 1, 0, 1, 0],
      [0, 0, 1, 0, 0],
    ],
    [
      [1, 0, 1, 0, 1],
      [0, 0, 0, 0, 0],
      [0, 1, 0, 1, 0],
    ],
    [
      [1, 1, 0, 0, 0],
      [0, 0, 1, 0, 0],
      [0, 0, 0, 1, 1],
    ],
    [
      [0, 0, 0, 0, 0],
      [1, 1, 1, 1, 1],
      [0, 0, 0, 0, 0],
    ],
    [
      [0, 1, 0, 1, 0],
      [1, 0, 1, 0, 1],
      [0, 0, 0, 0, 0],
    ],
    [
      [0, 1, 1, 1, 0],
      [1, 0, 0, 0, 1],
      [0, 0, 0, 0, 0],
    ],
    [
      [0, 1, 0, 1, 0],
      [1, 0, 0, 0, 1],
      [0, 0, 1, 0, 0],
    ],
    [
      [0, 0, 0, 0, 0],
      [1, 0, 1, 0, 1],
      [0, 1, 0, 1, 0],
    ],
    [
      [0, 0, 0, 0, 0],
      [1, 0, 0, 0, 1],
      [0, 1, 1, 1, 0],
    ],
    [
      [0, 0, 1, 0, 0],
      [1, 0, 0, 0, 1],
      [0, 1, 0, 1, 0],
    ],
    [
      [0, 0, 1, 0, 0],
      [1, 1, 0, 1, 1],
      [0, 0, 0, 0, 0],
    ],
    [
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [1, 1, 1, 1, 1],
    ],
    [
      [0, 0, 1, 0, 0],
      [0, 1, 0, 1, 0],
      [1, 0, 0, 0, 1],
    ],
    [
      [0, 0, 0, 0, 0],
      [0, 1, 0, 1, 0],
      [1, 0, 1, 0, 1],
    ],
    [
      [0, 0, 0, 0, 0],
      [0, 1, 1, 1, 0],
      [1, 0, 0, 0, 1],
    ],
    [
      [0, 1, 0, 1, 0],
      [0, 0, 0, 0, 0],
      [1, 0, 1, 0, 1],
    ],
    [
      [0, 0, 0, 1, 1],
      [0, 0, 1, 0, 0],
      [1, 1, 0, 0, 0],
    ],
  ],
  "5x3": [
    [
      [0, 0, 0, 0, 0],
      [1, 1, 1, 1, 1],
      [0, 0, 0, 0, 0],
    ],
    [
      [1, 1, 1, 1, 1],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
    ],
    [
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [1, 1, 1, 1, 1],
    ],
    [
      [1, 0, 0, 0, 1],
      [0, 1, 0, 1, 0],
      [0, 0, 1, 0, 0],
    ],
    [
      [0, 0, 1, 0, 0],
      [0, 1, 0, 1, 0],
      [1, 0, 0, 0, 1],
    ],
    [
      [1, 1, 0, 0, 0],
      [0, 0, 1, 0, 0],
      [0, 0, 0, 1, 1],
    ],
    [
      [0, 0, 0, 1, 1],
      [0, 0, 1, 0, 0],
      [1, 1, 0, 0, 0],
    ],
    [
      [0, 1, 0, 0, 0],
      [1, 0, 1, 0, 1],
      [0, 0, 0, 1, 0],
    ],
    [
      [0, 0, 0, 1, 0],
      [1, 0, 1, 0, 1],
      [0, 1, 0, 0, 0],
    ],
    [
      [0, 1, 1, 0, 1],
      [1, 0, 0, 1, 0],
      [0, 0, 0, 0, 0],
    ],
    [
      [0, 0, 0, 0, 0],
      [1, 0, 0, 1, 0],
      [0, 1, 1, 0, 1],
    ],
    [
      [1, 0, 1, 1, 0],
      [0, 1, 0, 0, 1],
      [0, 0, 0, 0, 0],
    ],
    [
      [0, 0, 0, 0, 0],
      [0, 1, 0, 0, 1],
      [1, 0, 1, 1, 0],
    ],
    [
      [1, 0, 1, 0, 1],
      [0, 0, 0, 0, 0],
      [0, 1, 0, 1, 0],
    ],
    [
      [0, 1, 0, 1, 0],
      [0, 0, 0, 0, 0],
      [1, 0, 1, 0, 1],
    ],
    [
      [0, 1, 0, 1, 0],
      [1, 0, 0, 0, 1],
      [0, 0, 1, 0, 0],
    ],
    [
      [0, 0, 1, 0, 0],
      [1, 0, 0, 0, 1],
      [0, 1, 0, 1, 0],
    ],
    [
      [1, 0, 0, 0, 1],
      [0, 1, 1, 1, 0],
      [0, 0, 0, 0, 0],
    ],
    [
      [0, 0, 0, 0, 0],
      [0, 1, 1, 1, 0],
      [1, 0, 0, 0, 1],
    ],
    [
      [1, 0, 0, 0, 1],
      [0, 0, 0, 0, 0],
      [0, 1, 1, 1, 0],
    ],
  ],
  "5x4": [
    [
      [1, 1, 1, 1, 1],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
    ],
    [
      [1, 0, 1, 0, 1],
      [0, 1, 0, 1, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
    ],
    [
      [1, 0, 0, 0, 1],
      [0, 1, 1, 1, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
    ],
    [
      [1, 0, 0, 0, 0],
      [0, 1, 0, 0, 0],
      [0, 0, 1, 0, 1],
      [0, 0, 0, 1, 0],
    ],
    [
      [0, 0, 0, 0, 0],
      [1, 1, 1, 1, 1],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
    ],
    [
      [0, 1, 0, 1, 0],
      [1, 0, 1, 0, 1],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
    ],
    [
      [0, 1, 1, 1, 0],
      [1, 0, 0, 0, 1],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
    ],
    [
      [0, 0, 0, 0, 0],
      [1, 0, 1, 0, 1],
      [0, 1, 0, 1, 0],
      [0, 0, 0, 0, 0],
    ],
    [
      [0, 0, 0, 0, 0],
      [1, 0, 0, 0, 1],
      [0, 1, 1, 1, 0],
      [0, 0, 0, 0, 0],
    ],
    [
      [0, 0, 0, 0, 0],
      [1, 0, 0, 0, 1],
      [0, 1, 0, 1, 0],
      [0, 0, 1, 0, 0],
    ],
    [
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [1, 1, 1, 1, 1],
      [0, 0, 0, 0, 0],
    ],
    [
      [0, 0, 1, 0, 0],
      [0, 1, 0, 1, 0],
      [1, 0, 0, 0, 1],
      [0, 0, 0, 0, 0],
    ],
    [
      [0, 0, 0, 0, 0],
      [0, 1, 0, 1, 0],
      [1, 0, 1, 0, 1],
      [0, 0, 0, 0, 0],
    ],
    [
      [0, 0, 0, 0, 0],
      [0, 1, 1, 1, 0],
      [1, 0, 0, 0, 1],
      [0, 0, 0, 0, 0],
    ],
    [
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [1, 0, 1, 0, 1],
      [0, 1, 0, 1, 0],
    ],
    [
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [1, 0, 0, 0, 1],
      [0, 1, 1, 1, 0],
    ],
    [
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [1, 1, 1, 1, 1],
    ],
    [
      [0, 0, 0, 1, 0],
      [0, 0, 1, 0, 1],
      [0, 1, 0, 0, 0],
      [1, 0, 0, 0, 0],
    ],
    [
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 1, 1, 1, 0],
      [1, 0, 0, 0, 1],
    ],
    [
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 1, 0, 1, 0],
      [1, 0, 1, 0, 1],
    ],
  ],
  "5x3-10lines": [
    [
      [0, 0, 0, 0, 0],
      [1, 1, 1, 1, 1],
      [0, 0, 0, 0, 0],
    ],
    [
      [1, 1, 1, 1, 1],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
    ],
    [
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [1, 1, 1, 1, 1],
    ],
    [
      [1, 0, 0, 0, 1],
      [0, 1, 0, 1, 0],
      [0, 0, 1, 0, 0],
    ],
    [
      [0, 0, 1, 0, 0],
      [0, 1, 0, 1, 0],
      [1, 0, 0, 0, 1],
    ],
    [
      [1, 1, 0, 0, 0],
      [0, 0, 1, 0, 0],
      [0, 0, 0, 1, 1],
    ],
    [
      [0, 0, 0, 1, 1],
      [0, 0, 1, 0, 0],
      [1, 1, 0, 0, 0],
    ],
    [
      [0, 1, 1, 1, 0],
      [1, 0, 0, 0, 1],
      [0, 0, 0, 0, 0],
    ],
    [
      [0, 0, 0, 0, 0],
      [1, 0, 0, 0, 1],
      [0, 1, 1, 1, 0],
    ],
    [
      [1, 0, 1, 0, 1],
      [0, 1, 0, 1, 0],
      [0, 0, 0, 0, 0],
    ],
  ],
  "6x3": [
    [
      [1, 1, 1, 1, 1, 1],
      [0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0],
    ],
    [
      [0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0],
      [1, 1, 1, 1, 1, 1],
    ],
    [
      [1, 0, 0, 0, 0, 1],
      [0, 1, 0, 0, 1, 0],
      [0, 0, 1, 1, 0, 0],
    ],
    [
      [0, 0, 1, 1, 0, 0],
      [0, 1, 0, 0, 1, 0],
      [1, 0, 0, 0, 0, 1],
    ],
    [
      [1, 0, 1, 0, 1, 0],
      [0, 1, 0, 1, 0, 1],
      [0, 0, 0, 0, 0, 0],
    ],
    [
      [0, 1, 0, 1, 0, 1],
      [1, 0, 1, 0, 1, 0],
      [0, 0, 0, 0, 0, 0],
    ],
    [
      [0, 0, 0, 0, 0, 0],
      [1, 0, 1, 0, 1, 0],
      [0, 1, 0, 1, 0, 1],
    ],
    [
      [0, 0, 0, 0, 0, 0],
      [0, 1, 0, 1, 0, 1],
      [1, 0, 1, 0, 1, 0],
    ],
    [
      [1, 0, 1, 0, 1, 0],
      [0, 0, 0, 0, 0, 0],
      [0, 1, 0, 1, 0, 1],
    ],
    [
      [0, 1, 0, 1, 0, 1],
      [0, 0, 0, 0, 0, 0],
      [1, 0, 1, 0, 1, 0],
    ],
    [
      [0, 1, 1, 1, 1, 0],
      [1, 0, 0, 0, 0, 1],
      [0, 0, 0, 0, 0, 0],
    ],
    [
      [1, 0, 0, 0, 0, 1],
      [0, 1, 1, 1, 1, 0],
      [0, 0, 0, 0, 0, 0],
    ],
    [
      [0, 0, 0, 0, 0, 0],
      [1, 0, 0, 0, 0, 1],
      [0, 1, 1, 1, 1, 0],
    ],
    [
      [0, 0, 0, 0, 0, 0],
      [0, 1, 1, 1, 1, 0],
      [1, 0, 0, 0, 0, 1],
    ],
    [
      [1, 0, 0, 0, 1, 0],
      [0, 1, 0, 1, 0, 1],
      [0, 0, 1, 0, 0, 0],
    ],
    [
      [0, 0, 1, 0, 0, 0],
      [0, 1, 0, 1, 0, 1],
      [1, 0, 0, 0, 1, 0],
    ],
    [
      [0, 0, 1, 1, 0, 0],
      [1, 1, 0, 0, 1, 1],
      [0, 0, 0, 0, 0, 0],
    ],
    [
      [0, 0, 1, 0, 0, 0],
      [1, 1, 0, 0, 1, 1],
      [0, 0, 0, 1, 0, 0],
    ],
  ]
};

export default lines;
